export default "__VITE_ASSET__CSWZdN7s__"